import React, {useState} from 'react'
import {
  Container,
  NewsContainer,
  StyledHeaderContainer,
  StyledNewsHeader,
  Subscribe,
} from './LastestNews.styled'
import PropTypes from 'prop-types'
import Heading, {HeadingSizeEnum} from '../Heading/Heading'
import Button from '../Button/Button'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import FooterModal from '../FooterModal/FooterModal'
import SearchCard from '../SearchCard/SearchCard'
import UrlFactory from '../../utils/UrlFactory'
import ContentType from "../../enums/ContentType";
import useMediaQuery from "../../hooks/useMediaQuery";
import {deviceMax} from "../../theme/breakpoints";
import { ArrowRightIcon } from '../SearchPaginator/SearchPaginator.styled'

const BUTTON_LABEL = 'All News'
const SUBSCRIBE = 'Subscribe to Alerts'

const LastestNews = ({title, news}) => {
  const [show, setShow] = useState(false)
  const isMobile = useMediaQuery(deviceMax.mobileL)

  const cards = news.map((card, index) => {
    const {
      categories,
      contentfulAsset,
      cloudinary,
      date,
      name,
      locationTitle,
      title,
      pageTitle,
      seoMetaDescription,
      slug,
      url,
    } = card.node
    const {id: contentType} = categories?.[0].sys.contentType.sys.type
    const {id} = categories?.[0].sys

    const to = UrlFactory.getRightUrlForSearch(contentType, slug)

    return (
      <SearchCard
        isInvestor={true}
        categories={categories}
        date={date}
        key={id || index}
        text={seoMetaDescription?.seoMetaDescription}
        title={name || locationTitle || title || pageTitle}
        to={to && to}
        document={
          contentType === ContentType.contentDocument
            ? {
              cloudinary,
              contentfulAsset,
              url,
            }
            : null
        }
      />
    )
  })

  return (
    <Container>
      <FooterModal
        show={show}
        isMobile={isMobile}
        onClose={() => {
          setShow(false)
        }}
      />
      <StyledNewsHeader>
        {title && <Heading label={title} size={HeadingSizeEnum.h2}/>}
        <StyledHeaderContainer>
          <Subscribe onClick={() => setShow(true)}>{SUBSCRIBE}</Subscribe>
          <Button
            variant={ButtonVariantEnum.secondary}
            to={'/news'}
          >
            {BUTTON_LABEL}
            <ArrowRightIcon/>
          </Button>
        </StyledHeaderContainer>
      </StyledNewsHeader>
      <NewsContainer>{cards}</NewsContainer>
    </Container>
  )
}

LastestNews.propTypes = {
  title: PropTypes.string.isRequired,
  news: PropTypes.array.isRequired,
}

export default LastestNews
